var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconLinkdin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z",
    fill: "#007AB9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5724 11.8853V16.4203H14.9431V12.1892C14.9431 11.1268 14.5634 10.4013 13.6114 10.4013C12.8849 10.4013 12.4534 10.8898 12.2628 11.3627C12.1935 11.5317 12.1757 11.7665 12.1757 12.0035V16.4201H9.5462C9.5462 16.4201 9.58149 9.25401 9.5462 8.51222H12.1759V9.63285C12.1706 9.64167 12.1632 9.6503 12.1584 9.65873H12.1759V9.63285C12.5253 9.09518 13.1485 8.32653 14.5456 8.32653C16.2755 8.32653 17.5724 9.45676 17.5724 11.8853ZM6.79551 4.70032C5.89607 4.70032 5.30762 5.29073 5.30762 6.06644C5.30762 6.82569 5.87901 7.43316 6.761 7.43316H6.77806C7.69515 7.43316 8.26537 6.82569 8.26537 6.06644C8.24792 5.29073 7.69515 4.70032 6.79551 4.70032ZM5.4639 16.4203H8.09242V8.51222H5.4639V16.4203Z",
    fill: "#F1F2F2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconLinkdin);
export default __webpack_public_path__ + "static/media/social-icon-linkdin.bdbccb19.svg";
export { ForwardRef as ReactComponent };